import { render, staticRenderFns } from "./InvestorProfile.vue?vue&type=template&id=5c1eab7d&scoped=true"
import script from "./InvestorProfile.vue?vue&type=script&lang=js"
export * from "./InvestorProfile.vue?vue&type=script&lang=js"
import style0 from "./InvestorProfile.vue?vue&type=style&index=0&id=5c1eab7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1eab7d",
  null
  
)

export default component.exports